import { IconButton, Tooltip, Typography, Zoom } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const styling = {
  iconStyle: { color: '$primary-color' },
  textStyle: { paddingLeft: '5px', color: '$primary-color' },
};

interface CellProps {
  count: number;
  icon: any;
  tooltip?: any;
  route?: string;
  onClick?: () => void;
  isDisabled?: boolean;
}

export const GridCountCell = ({ count, tooltip, icon, route, onClick, isDisabled }: CellProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (route) {
      navigate(route);
    }
    onClick?.();
  };

  return (
    <td>
      {/* {!isDisabled ? ( */}
      <Tooltip TransitionComponent={Zoom} title={tooltip} arrow placement="right">
        <span>
          <IconButton size="small" aria-label="count" disabled={count <= 0 || !!isDisabled} onClick={handleClick}>
            {icon}
            <Typography style={styling.textStyle} variant="body1">
              {count}
            </Typography>
          </IconButton>
        </span>
      </Tooltip>
      {/* // ) : (
      //   <Tooltip TransitionComponent={Zoom} title={'You don not have permission'} arrow placement="right">
      //     <IconButton size="small" aria-label="count" disabled={count <= 0}>
      //       {icon}
      //       <Typography style={styling.textStyle} variant="body1">
      //         {count}
      //       </Typography>
      //     </IconButton>
      //   </Tooltip>
      // )} */}
    </td>
  );
};
